
import { Directive, ElementRef, EventEmitter, Input, Output } from '@angular/core';


let /** @type {?} */ brace = require('brace');
export class AceEditorDirective {

  _text: string;
  _mode: string;
  _theme: string;
  _readOnly: boolean;
  _roptionseadOnly: boolean;
  editor: any;
  oldVal: any;

   textChanged = new EventEmitter<any>();
   editorRef = new EventEmitter<any>();
/**
 * @param {?} value
 * @return {?}
 */
set options(value: any) {
    this.editor.setOptions(value || {
      enableBasicAutocompletion: true,
      enableLiveAutocompletion: true
    });
  }
/**
 * @param {?} value
 * @return {?}
 */
set readOnly(value: boolean) {
    this._readOnly = value;
    this.editor.setReadOnly(value);
  }
/**
 * @param {?} value
 * @return {?}
 */
set theme(value: string) {
    this._theme = value || 'chrome';;
    this.editor.setTheme(`ace/theme/${value}`);
  }
/**
 * @param {?} value
 * @return {?}
 */
set mode(value: string) {
    this._mode = value || 'javascript';
    this.editor.getSession().setMode(`ace/mode/${value}`);
  }
/**
 * @param {?} value
 * @return {?}
 */
set text(value: string) {
    if (value === this.oldVal) return;
    this.editor.setValue(value);
    this.editor.clearSelection();
    this.editor.focus();
  }
/**
 * @param {?} elementRef
 */
constructor(private elementRef: ElementRef) {
    const el = elementRef.nativeElement;
    el.classList.add('editor');
    this.editor = brace.edit(el);

    setTimeout(() => {
      this.editorRef.emit(this.editor);
    });
    this.editor.on('change', () => {
      const newVal = this.editor.getValue();
      if (newVal === this.oldVal) return;
      if (typeof this.oldVal !== 'undefined') {
        this.textChanged.emit(newVal);
      }
      this.oldVal = newVal;
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[ace-editor]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'textChanged': [{ type: Output },],
'editorRef': [{ type: Output },],
'options': [{ type: Input },],
'readOnly': [{ type: Input },],
'theme': [{ type: Input },],
'mode': [{ type: Input },],
'text': [{ type: Input },],
};
}

function AceEditorDirective_tsickle_Closure_declarations() {
/** @type {?} */
AceEditorDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AceEditorDirective.ctorParameters;
/** @type {?} */
AceEditorDirective.propDecorators;
/** @type {?} */
AceEditorDirective.prototype._text;
/** @type {?} */
AceEditorDirective.prototype._mode;
/** @type {?} */
AceEditorDirective.prototype._theme;
/** @type {?} */
AceEditorDirective.prototype._readOnly;
/** @type {?} */
AceEditorDirective.prototype._roptionseadOnly;
/** @type {?} */
AceEditorDirective.prototype.editor;
/** @type {?} */
AceEditorDirective.prototype.oldVal;
/** @type {?} */
AceEditorDirective.prototype.textChanged;
/** @type {?} */
AceEditorDirective.prototype.editorRef;
/** @type {?} */
AceEditorDirective.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
